export default __webpack_public_path__ + "static/media/safari-settings-steps-ios-aa.d98da881.png";